import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      username: 'rofl',
      fullName: 'Roflcopter man'
    },
    count: 1
  },
  getters: {},
  mutations: {
    INCREMENT_COUNT(state, payload) {
      state.count += Number(payload)
    }
  },
  actions: {}
});



// WEBPACK FOOTER //
// ./src/datastore/vuexDataStore.js